import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import {get, template, clone} from 'lodash';
import prettyPhone from '../../../../../../lib/prettyPhone';

@connect(store => ({
  labels: get(store.labels, 'AlreadyExists', {}),
}))
export default class AlreadyExists extends Component {

  propTypes = {
    firstName: PropTypes.string,
    assignedSpecialist: PropTypes.object,
    labels: PropTypes.object.isRequired,
  };

  render() {
    const props = clone(this.props);
    props.assignedSpecialist = props.assignedSpecialist || {};
    props.assignedSpecialist.phoneNumber = prettyPhone(get(props.assignedSpecialist, 'phoneNumber')) || 'N/A';
    const html = template(this.props.labels.message)(props);
  return (
    <div className='already-exists-message' dangerouslySetInnerHTML={{__html: html}}>
    </div>
  );
 }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/f_AlreadyExists/index.js